import React, { Component } from 'react'
import { Spin, Form, Button, Table, Layout, Icon, Row, Col, Select, Upload, Modal, Input, Switch, message, InputNumber } from 'antd'
import { goodsCategoryList, goodsTypeSave, goodsTypeDetail, goodsTypeChange } from '_src/api/api'
import PrevImg from '_src/components/PrevImg/PrevImg'
import { UploadIMGToOss } from '_src/utils/base'

const { TextArea, Search } = Input
const { Option } = Select
const uploadButton = (
  <div>
    <Icon type="plus" />
    <div className="ant-upload-text">图片上传</div>
  </div>
)
@Form.create({ name: '' })
class GoodType extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileList: [],

      isLoading: false,
      issubmit: false,
      createModelVisible: false,

      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0,
        current: 1,
      },

      list: [],
      goodscategorylist: [],
      columns: [
        {
          title: <span>编号</span>,
          align: 'center',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: <span>上级分类</span>,

          align: 'center',
          dataIndex: 'parent',
          render: item => {
            return <div>{item ? item.name : '无'}</div>
          }
        },
        {
          title: <span>类型名称</span>,
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: <span>排序</span>,
          align: 'center',
          dataIndex: 'sortOrder',
        },
        {
          title: <span>创建日期</span>,
          align: 'center',
          dataIndex: 'createAt',
        },
        {
          title: <span>使用状态</span>,
          align: 'center',
          dataIndex: 'status',
          render: item => <div>{item === 1 ? <Icon type="check-circle" theme="twoTone" style={{ color: 'green', fontSize: 20 }} /> : <Icon type="close-circle" theme="filled" style={{ color: '#ccc', fontSize: 18 }} />}</div>
        },
        {
          title: <span>导航栏</span>,
          align: 'center',
          dataIndex: 'isNavigation',
          render: item => <div>{item === true ? <Icon type="check-circle" theme="twoTone" style={{ color: 'green', fontSize: 20 }} /> : <Icon type="close-circle" theme="filled" style={{ color: '#ccc', fontSize: 18 }} />}</div>
        },
        {
          title: <span>简介</span>,
          align: 'center',
          dataIndex: 'desc',
        },
        {
          title: <span>操作</span>,
          align: 'center',
          width: 280,
          render: item => <div>
            <Button icon="edit" onClick={() => { this.edit(item.id) }} style={{ marginRight: '10px' }}>编辑</Button>
            <Switch disabled={item.status === 0} checkedChildren="启用" unCheckedChildren="禁用" checked={item.status === 1} onChange={(checked) => this.statusChange(checked, item.id)} />
          </div>,
        },
      ]

    }
  }


  // 广告图
  handleChange = ({ fileList }) => {
    this.setState({ fileList, upload: true })
  }

  // 预览图片
  handlePreview = (e) => {
    this.PrevImg.show(e.thumbUrl || e.url)
  }


  componentDidMount() {
    const { params } = this.state
    this.loadList(params)
    this.loadCategoryList()
  }

  /** 组装分类查询参数；status 仅在为 0 或 1 时传给接口 */
  buildCategoryQuery = (extra = {}) => {
    const query = { ...extra }
    if (query.status !== 0 && query.status !== 1) {
      delete query.status
    }
    return query
  }

  loadCategoryList = (pid, status) => {
    const query = this.buildCategoryQuery({
      pageSize: -1,
      pid: pid !== undefined && pid !== null ? pid : 0,
    })
    if (status === 0 || status === 1) {
      query.status = status
    }
    goodsCategoryList(query).then(res => {
      this.setState({
        goodscategorylist: res.data
      })
    })
  }


  loadList(params) {
    this.setState({ isLoading: true })
    goodsCategoryList(this.buildCategoryQuery(params))
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }
  // 编辑
  edit = (id) => {
    goodsTypeDetail({ id })
      .then(res => {
        const fileList = res.data.picUrl ? [{ uid: 0, name: 'xxx.png', status: 'done', url: res.data.picUrl }] : []

        this.setState({
          info: res.data,
          photo: res.data.picUrl,
          upload: false,
          createModelVisible: true,
          fileList,
        }, () => {
          this.props.form.setFieldsValue({
            pid: res.data.parent ? res.data.parent.id : 0,
            name: res.data.name,
            desc: res.data.desc,
            sortOrder: res.data.sortOrder,
            status: res.data.status === 1,
            isNavigation: res.data.isNavigation === true,
            picUrl: res.data.picUrl,
          })
        })
      })
  }
  statusChange = (checked, id) => {
    const title = checked ? '确定要启用当前分类?' : '确定要禁用当前分类?'
    const content = checked ? '启用该分类后，该分类的所有商品将恢复上架！' : '禁用该分类后，该分类的所有商品将下架!'
    const postArr = [id]
    const _this = this
    Modal.confirm({
      title: title,
      content: content,
      maskClosable: true,
      onOk() {
        goodsTypeChange(postArr)
          .then(() => {
            message.success('禁用成功', 1.5, () => {
              const { params } = _this.state
              params.pageNum = 0
              _this.loadList(params)
            })
          })
      },
      onCancel() {
        // 取消操作
      },
    })
  }
  // 创建
  create = () => {
    this.props.form.resetFields()
    this.setState({
      createModelVisible: true,
      fileList: [],
      upload: false,
      info: null,
    })
  }

  // 创建元素
  createModal = (info) => {
    const { getFieldDecorator } = this.props.form
    return (
      <Form onSubmit={this.handleSubmit} className="discount-form">
        <Form.Item label="上级分类" className='flex'>
          {getFieldDecorator('pid', {
            rules: [{ required: true, message: '请选择上级分类' }],
            initialValue: info && info.parent ? info.parent.id : 0,
          })(
            <Select placeholder="请选择上级分类" disabled={info && info.goodsCategories && info.goodsCategories.length>0} style={{ width: 180 }}>
              <Option value={0}>无</Option>
              {
                this.state.goodscategorylist.map((item, index) => {
                  if (info && item.id === info.id) {
                  }else{
                    return (<Option key={index} value={item.id}>{item.name}</Option>)
                  }
                })
              }
            </Select>,
          )}
        </Form.Item>
        <Form.Item label="分类名称：" className='flex'>
          {getFieldDecorator('name', {
            rules: [{
              required: true,
              message: '请输入商品分类名称',
            }],
            initialValue: info && info.name ? info.name : '',
          })(
            <Input placeholder="商品分类名称" />
          )}
        </Form.Item>

        <Form.Item label="分类简介：" className='flex'>
          {getFieldDecorator('desc', {
            rules: [{
              required: true,
              message: '请输入分类简介',
            }],
            initialValue: info && info.desc ? info.desc : '',
          })(
            <TextArea placeholder="分类简介" />
          )}
        </Form.Item>
        <Form.Item label="分类排序：" className='flex'>
          {getFieldDecorator('sortOrder', {
            initialValue: info && info.sortOrder ? info.sortOrder : 1,
          })(
            <InputNumber placeholder="分类排序" />
          )}
          （数字越小排序越靠前）
        </Form.Item>
        <Form.Item label="使用状态：" className='flex'>
          {getFieldDecorator('status', {
            valuePropName: 'checked',
            initialValue: info ? info.status === 1 : false,
          })(
            <Switch checkedChildren="启用" unCheckedChildren="禁用" />
          )}
        </Form.Item>
        <Form.Item label="导航栏分类：" className='flex'>
          {getFieldDecorator('isNavigation', {
            valuePropName: 'checked',
            initialValue: info && info.isNavigation === true ? true : false
          })(
            <Switch checkedChildren="是" unCheckedChildren="否" />
          )}
        </Form.Item>
        <Form.Item label="分类图标：" className='flex'>
          {getFieldDecorator('picUrl', {
            rules: [{
              required: true,
              message: '请上传分类图标.',
            }],
            initialValue: info ? info.picUrl : '',
          })(
            // <Upload
            //   listType="picture-card"
            //   fileList={fileList}
            //   onPreview={this.handlePreview}
            //   onChange={this.handleChange}
            //   customRequest={()=>{}}
            //   // beforeUpload = {()=>{ return false }}
            // >
            //   {fileList.length >= 1 ? null : uploadButton}
            // </Upload>
            <Upload
              action=""
              listType="picture-card"
              fileList={this.state.fileList}
              onPreview={this.handlePreview}
              onChange={this.handleChange}
              beforeUpload={() => { return false }}
            >
              {this.state.fileList.length >= 1 ? null : uploadButton}
            </Upload>
          )}
          <div> （尺寸：750 * 380）</div>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={this.state.issubmit} style={{ width: 300, marginLeft: 20 }}>保存</Button>
        </Form.Item>

      </Form>
    )
  }

  // 提交创建优惠券
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        values.sortOrder = Number(values.sortOrder)
        values.status = values.status ? 1 : 0

        // 当前是否为编辑
        let isEdit = false
        const { info } = this.state
        if (info) {
          isEdit = true
          values.id = info.id
        }
        const hide = message.loading('数据提交中', 0)
        this.setState({ issubmit: true })
        const { fileList, upload } = this.state
        if (upload && fileList.length) {
          values.picUrl = await UploadIMGToOss(fileList[0])
        } else {
          values.picUrl = this.state.info.picUrl
        }
        goodsTypeSave(values, isEdit)
          .then(() => {
            hide()
            this.setState({
              createModelVisible: false,
              info: '',
              issubmit: false
            })
            message.success('提交成功！', 1.2, () => {
              const { params } = this.state
              params.pageNum = 0
              this.loadList(params)
            })
          })
          .catch(e => {
            this.setState({
              issubmit: false
            })
          })
      }
    })
  }
  SelectChange = (v) => {
    let { params } = this.state
    params.pageNum = 0
    params.pid = v === -1 ? null : v
    this.loadList(params)
  }

  onStatusFilterChange = (v) => {
    let { params } = this.state
    params.pageNum = 0
    if (v === -1) {
      delete params.status
    } else {
      params.status = v
    }
    this.setState({ params }, () => {
      this.loadList(params)
      this.loadCategoryList(params.pid, params.status)
    })
  }
  render() {
    const {
      isLoading,
      list,
      columns,
      pageData,
      createModelVisible,
      info,
    } = this.state
    return (
      <Layout className="goodType-page" style={{ padding: 20, backgroundColor: 'white' }}>
        {this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <div style={{ paddingBottom: 20 }}>
          <Button className='creat-station' type="primary" icon="plus" style={{ width: 160 }} onClick={this.create}>添加商品分类</Button>
        </div>
        <Form className="goodlist_from">
          <div style={{ maxWidth: 900 }}>
            <Row gutter={24}>

              <Col span={8}>
                <Form.Item label="上级分类">
                  <Select placeholder="请选择商品分类" showSearch onChange={this.SelectChange} >
                    <Option key={-1} value={-1}>显示所有</Option>
                    <Option key={0} value={0}>无</Option>
                    {
                      this.state.goodscategorylist.map((item, index) => {
                        return (<Option key={index} value={item.id}>{item.name}</Option>)
                      })
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="使用状态">
                  <Select placeholder="全部" defaultValue={-1} onChange={this.onStatusFilterChange}>
                    <Option key="status-all" value={-1}>全部</Option>
                    <Option key="status-on" value={1}>启用</Option>
                    <Option key="status-off" value={0}>禁用</Option>
                  </Select>
                </Form.Item>
              </Col>

            </Row>
          </div>
        </Form>
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
        <Modal
          title="创建商品分类"
          visible={createModelVisible}
          onCancel={() => {
            this.setState({
              createModelVisible: false,
              info: '',
            })
          }}
          width={430}
          footer={false}
          destroyOnClose
        >
          {this.createModal(info)}
        </Modal>
      </Layout>
    )
  }
}

export default GoodType